module.exports = __webpack_public_path__ + "img/风险评估-bg.81cfb271.jpg";